// extracted by mini-css-extract-plugin
module.exports = {"willBeSoon":"willBeSoon_willBeSoon__ttJoY","willBeSoon__body":"willBeSoon_willBeSoon__body___6E4Q","willBeSoon__text":"willBeSoon_willBeSoon__text__jT0Ow"};